/*
 * KindListePaginated3.tsx Entities einer "Kind" als Liste Paginiert darstellen.
 *
 * Created by Dr. Maximillian Dornseif 2023-11-04 in huWaWi3 33.4.0
 * Copyright (c) 2023 HUDORA GmbH
 */

// Entyities einer "Kind" Paginated als Liste darstellen
// Die eigentliche Darstellung macht ein <EntityTable3 />

import { ICommandBarItemProps } from '@fluentui/react';
import { useDebounce } from '@hudora/hd-react-components';
import reverse from 'lodash.reverse';
import sortBy from 'lodash.sortby';
import pThrottle from 'p-throttle';
import React, { useEffect, useMemo, useState } from 'react';
import { NumberParam, useQueryParam } from 'use-query-params';

import { useAddPanel3 } from '../../hooks/useAddPanel3';
import { usePaginatedQuery } from '../../hooks/usePaginatedQuery';
import { IKindListe3Props } from './KindListe3';
import { KTTheEntityTable3 } from './KindListeHelpers3';

// max 3 calls in 0.7 seconds
const throttle = pThrottle({
  limit: 3,
  interval: 700,
});

export interface IKindListePaginated3Props extends IKindListe3Props {
  initialLimit?: number; // Anzahl der anfangs angezeigten Datensätzen
  // bulkEditKeyField?: string // bulkEditor aktivieren
}
/**
 * Zeigt eine Liste mit Entities.
 * Das ist die default Seite für zB den "Kunden" Bereich.
 * Steht in sehr engem Zusammenhang mit <SchemaTable>,
 * siehe auch dort die Dokumentation.
 */

export const KindListePaginated3 = (props: IKindListePaginated3Props) => {
  const [urlLimit, setUrlLimit] = useQueryParam('limit', NumberParam);
  const [limit, setLimit] = useState(urlLimit || props.initialLimit || 100);
  const {
    fetching,
    stale,
    data,
    nodes,
    error,
    // operation,
    execute,
    isLoadingInitial,
    canFetchMore,
    isFetchingMore,
    fetchMore,
    // revalidate,
  } = usePaginatedQuery(
    props.listQuery as any,
    {
      variables: useMemo(() => {
        return {
          limit,
          // any other variables, besides offset
        };
      }, []), // be sure to memoize
    },
    {}
  );
  const slowFetchMore = throttle(() => fetchMore());
  const debouncedFetching = useDebounce(fetching, 50);

  const [createItem, createPanel, createButton] = useAddPanel3({
    ...props,
  });

  const items: Array<ICommandBarItemProps> = [createItem];
  // Automatisch mehr laden, wenn das noch nötig ist.
  useEffect(() => {
    if (canFetchMore && nodes?.length < limit && nodes?.length > 0) {
      slowFetchMore();
    }
  }, [canFetchMore, nodes?.length, limit]);

  if (canFetchMore) {
    const item: ICommandBarItemProps = {
      key: 'mehrLaden',
      text: 'mehr laden',
      ariaLabel: 'mehr laden',
      iconProps: {
        iconName: debouncedFetching ? 'HourGlass' : 'AppIconDefaultAdd',
      },
      iconOnly: false,
      onClick: () => {
        setLimit(limit * 2);
        setUrlLimit(limit * 2);
        // slowFetchMore()
      },
    };
    item.disabled = debouncedFetching;
    items.push(item);
  }
  console.log('more!', canFetchMore, !fetching, nodes?.length, limit, nodes?.length <= limit);

  return (
    <React.Fragment>
      <KTTheEntityTable3
        {...props}
        createPanel={createPanel}
        // createButton={createButton}
        loading={fetching && !isFetchingMore}
        error={error}
        commandBarItems={items}
        rowData={nodes}
      />
    </React.Fragment>
  );
};
